import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiRequest } from '../config/api';
import { useToast } from '../context/ToastContext';
import PageBuilderComponent from '../components/PageBuilder';

export default function PageBuilder() {
  const { id: pageId } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();

  const [page, setPage] = useState(null);

  const [saving, setSaving] = useState(false);

  const fetchPage = useCallback(async () => {
    try {
      const response = await apiRequest(`/pages/${pageId}`);

      if (response.ok) {
        const pageData = await response.json();
        setPage(pageData);
      } else {
        throw new Error('Failed to fetch page');
      }
    } catch (error) {
      console.error('Error fetching page:', error);
      showError('Failed to load page');
      navigate('/pages');
    } 
  }, [pageId, navigate, showError]);

  useEffect(() => {
    fetchPage();
  }, [pageId, fetchPage]);

  const handleSave = async (updatedPageData) => {
    try {
      setSaving(true);
      const response = await apiRequest(`/pages/${pageId}`, {
        method: 'PUT',
        body: JSON.stringify(updatedPageData),
      });

      if (response.ok) {
        const savedPage = await response.json();
        setPage(savedPage);
        showSuccess('Page saved successfully');
      } else {
        throw new Error('Failed to save page');
      }
    } catch (error) {
      console.error('Error saving page:', error);
      showError('Failed to save page');
    } finally {
      setSaving(false);
    }
  };



  if (!page) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600">Page not found</p>
          <button
            onClick={() => navigate('/pages')}
            className="mt-4 px-4 py-2 bg-brand-600 text-white rounded-md hover:bg-brand-700"
          >
            Back to Pages
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
  
  

      {/* Page Builder Component */}
      <PageBuilderComponent
        page={page}
        onSave={handleSave}
        saving={saving}
        onRefreshPage={fetchPage}
      />
    </div>
  );
}